export const trimText = (text, trimmingLenght) => {
  if (typeof text !== "string" || text.length < 15) return text;
  return text.slice(0, trimmingLenght) + "...";
};
export const emailCapitalize = (email) => {
  return email.charAt(0).toUpperCase() + email.slice(1).toLowerCase();
};
export const dateFormatter = (date) => {
  return date.split("T")[0];
};
export const decodeHtml = (content) => {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = content;
  return textarea.value;
};
